/* MRF theme switch · v1 · 2026-09-02
   Один файл: bootstrap (без мигання) + кнопка ◐ (лише атрибути, без innerHTML) + рядок у футері/бургері + підказка в статті.
   Підключати в <head> ДО стилів: <script src="{{ 'mrf-theme.js' | asset_url }}"></script>
   Дефолт — DARK. AUTO = prefers-color-scheme. Ключ localStorage: mrfTheme. */
(function () {
  if (window.__mrfThemeInit) return; window.__mrfThemeInit = true;
  var KEY = 'mrfTheme', HINT_KEY = 'mrfThemeHint', MODES = ['dark', 'paper'];
  var html = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;

  function stored() { try { var v = localStorage.getItem(KEY); return MODES.indexOf(v) > -1 ? v : 'dark'; } catch (e) { return 'dark'; } }
  function resolve(mode) { return mode === 'auto' ? (mq && mq.matches ? 'paper' : 'dark') : mode; }
  function apply(mode) {
    html.setAttribute('data-theme-mode', mode);           // dark | paper | auto  (що вибрано)
    html.setAttribute('data-theme', resolve(mode));       // dark | paper         (що показуємо)
    html.style.colorScheme = resolve(mode) === 'paper' ? 'light' : 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(paintButton);
    document.querySelectorAll('[data-theme-seg]').forEach(paintSeg);
  }
  function set(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    apply(mode);
    /* наряд 04.09: подія лише на ДІЮ людини — apply() зі стартом сторінки її не шле */
    try { if (window.mrfTrack) window.mrfTrack('theme_switch', { theme: resolve(mode), mode: mode }); } catch (e) {}
  }
  function next() { var m = stored(); set(MODES[(MODES.indexOf(m) + 1) % MODES.length]); }

  /* --- кнопка ◐ у шапці: іконки лежать у розмітці, JS міняє лише data-mode (безпечно для React/Liquid-редактора) --- */
  var LABEL = { dark: 'Theme: Dark — click for Light', paper: 'Theme: Light — click for Dark', auto: 'Theme: Light — click for Dark' };
  function paintButton(btn) {
    var m = stored();
    btn.setAttribute('aria-label', LABEL[m]); btn.setAttribute('title', LABEL[m]); btn.setAttribute('data-mode', m);
  }
  function paintSeg(seg) {
    var m = stored();
    seg.querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false'); });
  }

  /* --- bootstrap: до першого кадру (після оголошення LABEL/ICON) --- */
  apply(stored());
  if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (stored() === 'auto') apply('auto'); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (t) { e.preventDefault(); next(); return; }
    var s = e.target.closest && e.target.closest('[data-theme-seg] [data-mode]');
    if (s) { e.preventDefault(); set(s.getAttribute('data-mode')); return; }
    var h = e.target.closest && e.target.closest('[data-theme-hint]');
    if (h) {
      if (e.target.closest('[data-hint-switch]')) { set('paper'); dismissHint(h); }
      else if (e.target.closest('[data-hint-close]')) dismissHint(h);
    }
  });

  /* --- підказка в статті: лише журнал, лише коли тема ще не обрана, один раз на пристрій --- */
  function dismissHint(el) { try { localStorage.setItem(HINT_KEY, '1'); } catch (e) {} el.hidden = true; }
  function initHint() {
    var el = document.querySelector('[data-theme-hint]'); if (!el) return;
    var chosen = null; try { chosen = localStorage.getItem(KEY); } catch (e) {}
    var seen = null; try { seen = localStorage.getItem(HINT_KEY); } catch (e) {}
    var ok = !chosen && !seen; // перший візит у статтю без обраної теми — на будь-якому пристрої
    el.hidden = !ok;
  }

  /* --- data-paper fallback: якщо шаблон/рантайм зняв атрибут з кореня, ставимо його на верхній контейнер статті (той, що містить підказку) --- */
  function ensurePaperRoot() {
    if (document.querySelector('[data-paper]')) return;
    var h = document.querySelector('[data-theme-hint]'); if (!h) return;
    var el = h;
    while (el.parentElement && el.parentElement !== document.body && el.parentElement.tagName !== 'X-DC') el = el.parentElement;
    el.setAttribute('data-paper', '1');
  }
  document.addEventListener('DOMContentLoaded', function () { apply(stored()); ensurePaperRoot(); initHint(); });
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (!document.querySelector('[data-paper]')) ensurePaperRoot();
      document.querySelectorAll('[data-theme-toggle]:not([data-mode])').forEach(paintButton);
      document.querySelectorAll('[data-theme-seg]').forEach(function (s) { if (!s.querySelector('[aria-pressed]')) paintSeg(s); });
    });
    document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
  }
  window.MRFTheme = { get: stored, set: set, next: next, resolved: function () { return resolve(stored()); } };
})();
